import { MutationConfig } from '@/utils/reactQuery'
import { getConfigOptions } from './getConfig'
import { MutationFunction, useMutation, useQueryClient } from '@tanstack/react-query'
import { OidcClientConfig } from '../types/authTypes'

type LogoutCallbackMutationFunctionProps = {
  idToken: string
}

type LogoutRedirectProps = LogoutCallbackMutationFunctionProps & {
  config: OidcClientConfig
}

const logoutRedirect = async ({ config, idToken }: LogoutRedirectProps) => {
  const logoutUrl = new URL(config.end_session_endpoint)
  const logoutParams = new URLSearchParams()
  logoutParams.set('client_id', import.meta.env.VITE_AUTH_CLIENT_ID)
  logoutParams.set('post_logout_redirect_uri', import.meta.env.VITE_AUTH_LOGOUT_REDIRECT_URI)
  logoutParams.set('id_token_hint', idToken)
  logoutUrl.search = logoutParams.toString()
  window.location.href = logoutUrl.toString()
}

type UseLogoutCallbackProps = {
  mutationConfig?: MutationConfig<MutationFunction<void, LogoutCallbackMutationFunctionProps>>
}

const useLogoutRedirect = ({ mutationConfig }: UseLogoutCallbackProps = {}) => {
  const { ...restConfig } = mutationConfig || {}
  const queryClient = useQueryClient()

  return useMutation({
    ...restConfig,
    mutationFn: async ({ idToken }: LogoutCallbackMutationFunctionProps) => {
      const configQuery = getConfigOptions()
      const config = queryClient.getQueryData(configQuery.queryKey) ?? (await queryClient.fetchQuery(configQuery))
      logoutRedirect({ config, idToken })
    },
  })
}

export { logoutRedirect, useLogoutRedirect }
